import { ClearStateActionTypes } from './clear-state.actions';

export interface State {}

export function clearState(reducer) {
  return function(state, action) {
    if (action.type === ClearStateActionTypes.LOGOUT) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
